import axios from 'axios'
import router from './router'
import { store } from './store.js';

let cancel;

String.prototype.trimChars = function (c) {
    var re = new RegExp("^[" + c + "]+|[" + c + "]+$", "g");
    return this.replace(re,"");
}

/*
let path = window.location.pathname.trimChars('/').split( '/' )
path = path && path[0] ? '/' + path[0] : ''
*/
window.useScopeSlugUrl = false;

window.intervalNotice = null;
window.axios = axios;
window.axios.defaults.baseURL = window.apiUrl + '/v1/admin/';
window.axios.interceptors.request.use(function(config){

    // Cancel previous request
    config.cancelToken = new window.axios.CancelToken(function executor(c) {
        // An executor function receives a cancel function as a parameter
        cancel = c;
    })


    if( config.url.indexOf('/import') >= 0 ){
        // No loader
    }else{
        $("#loader").fadeIn(180);
        setTimeout(function(){
            $("#loader").fadeOut(180);
        }, 180000);
    }

    config.headers['Authorization'] =  'Bearer ' + localStorage.getItem('token')
    config.headers['Accept'] =  'application/json'
    config.headers['X-WEEBOX-CLIENT'] =  localStorage.getItem('client')?localStorage.getItem('client'):document.head.querySelector("[name='X-WEEBOX-CLIENT']").content
    config.headers['X-WEEBOX-BACKEND'] =  true
    config.headers['Accept-Language'] =  'fr-CH'

    if( useScopeSlugUrl ){

        let scope_id = config && config.data && config.data.scope_id ? config.data.scope_id : null

        console.log("COMPARE SCOPE", scope_id, store.state.scope.id)
        console.log("SCOPES", store.state.scopes);

        if( scope_id != null && scope_id != store.state.scope.id ){
            let ressource = config.url.split('/v1/admin/')[1];
            if( store.state.scopes[scope_id] ){
                console.log("use another slug for url", store.state.scopes[scope_id].slug )
                config.url = window.apiUrl + '/' + store.state.scopes[scope_id].slug + '/v1/admin/' + ressource;
            }
        }

        console.log("URL", config.url)

    }

    return config;
})

window.axios.interceptors.response.use(function(response) {
    $("#loader").fadeOut(300);
    return response;
}, function(error) {
    if( error.response ){
        console.log("ERROR", error);
        $("#loader").fadeOut(300);
        document.getElementById("weebox-notice").className = "";
        if(error.response.status == '401'){
            router.push("/login")
        }else{
            if(error.response.status == '500'){
                //alert(error.response.data.message)

                var errorMsg = error.response.data.message ? error.response.data.message : error.response.data.exception ? error.response.data.exception : '';
                document.getElementById("weebox-notice-message").innerHTML = errorMsg;
                document.getElementById("weebox-notice").className = "show";
                clearTimeout(window.intervalNotice);
                window.intervalNotice = setTimeout(function(){
                    document.getElementById("weebox-notice").className = "";
                }, 10000);

            }else{
                var messages = error.response.data.errors;
                var messages_string = [];
                //alert(error.response.data.message + ' ' + messages.join('\n\r'))
                for (var key in messages) {
                    // skip loop if the property is from prototype
                    if (!messages.hasOwnProperty(key)) continue;

                    var obj = messages[key];
                    for (var prop in obj) {
                        // skip loop if the property is from prototype
                        if(!obj.hasOwnProperty(prop)) continue;
                        messages_string.push(key + " = " + obj[prop])
                        // your code
                        //alert(key + " = " + obj[prop]);
                    }
                }
                //alert(error.response.data.message + '\r' + messages_string.join('\r'))
                var errorMsg = error.response.data.message ? error.response.data.message : error.response.data.exception ? error.response.data.exception : '';
                document.getElementById("weebox-notice-message").innerHTML = errorMsg + '\r' + messages_string.join('\r');
                document.getElementById("weebox-notice").className = "show";
                clearTimeout(window.intervalNotice);
                window.intervalNotice = setTimeout(function(){
                    document.getElementById("weebox-notice").className = "";
                }, 10000);
            }
        }
        return Promise.reject(error.response);
    }

    //return Promise.reject({data:null});

});

export function Api() {
    if(cancel){ cancel(); }
    return window.axios
}


// WEBPACK FOOTER //
// ./src/Api.js